// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"62c35f2a","142":"ac791c64","152":"7eeaef92","645":"473a01dd"}[chunkId] + ".chunk.js";
};